// extracted by mini-css-extract-plugin
export var teamGalleryWrapper = "Team-module--teamGalleryWrapper--jWQGL";
export var text = "Team-module--text--j22VF";
export var textWrapper = "Team-module--textWrapper--wqPsk";